package org.zest.insan_360_website.data.page_states

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import org.zest.insan_360_website.pages.RegisterState
import org.zest.insan_360_website.pages.SignUpState

object SignUpPageState {
    var isLoading by mutableStateOf(false)
    var signUpState by mutableStateOf(SignUpState())
    var currentRegState by mutableStateOf(RegisterState.Default)
    var isRevealed by mutableStateOf(false)
    var isRevealedConfirm by mutableStateOf(false)

    fun reset() {
        isLoading = false
        signUpState = SignUpState()
        currentRegState = RegisterState.Default
        isRevealed = false
        isRevealedConfirm = false
    }
}